<template>

  <v-dialog
    v-model="show"
    persistent
    max-width="900">
    <v-card>
        <v-toolbar dense class="mb-4" color="primary" dark>
           {{state=='new'?'Add':'Edit'}} Product 
           <v-spacer/>
           <v-icon @click="emitToParent('close')">mdi-close</v-icon>
        </v-toolbar>
        <v-card-text>
          <v-form
                ref="form"
                v-model="valid"
                lazy-validation
              >
          <v-row dense>
              <v-col cols="6">
                  <v-row dense no-gutters>
                  <v-autocomplete
                      v-model="product.type"
                      label="Type"
                      dense
                      outlined
                      :rules="textRules"
                      required
                      :items="['content','empties']"
                    />

                     <v-autocomplete
                     v-if="product.type=='empties'"
                     class="ml-2"
                      v-model="product.empty_component"
                      label="Empty component"
                      dense
                      outlined
                      :items="['complete','shell', 'bottle']"
                    />
                  </v-row>
                    <v-text-field 
                      v-model="product.code"
                      label="Code"
                      :rules="textRules"
                      required
                      dense
                      outlined
                    />
                    <v-text-field 
                      v-model="product.description"
                      label="Description"
                      :rules="textRules"
                      required
                      dense
                      outlined
                    />
                   <v-autocomplete
                      v-model="product.category"
                      label="Category"
                      :rules="textRules"
                      required
                      dense
                      outlined
                      item-text="name"
                      item-value="id"
                      :items="$store.state.categories"
                    />
                    <v-text-field 
                      v-model="product.price_per_unit"
                      label="Unit price"
                      dense
                      outlined
                    />
                    <v-autocomplete
                      v-model="product.supplier"
                      label="Manufacturer/Supplier"
                      :rules="textRules"
                      required
                      dense
                      outlined
                      item-text="company"
                      item-value="id"
                      :items="$store.state.suppliers"
                    />
                   <v-text-field 
                  v-model="product.sort"
                  label="Sort"
                  dense
                  persistent-hint
                  type="number"
                  hint="Product listing order"
                  outlined
                />
              </v-col>
               <v-col cols="6">
                
                <v-text-field 
                  v-model="product.volume"
                  label="Volume"
                  dense
                  outlined
                />

                <v-text-field 
                  v-model="product.weight"
                  label="Weight"
                  dense
                  outlined
                />
                <v-autocomplete
                  v-model="product.size_type"
                  label="Size type"
                  :items="SIZES"
                  dense
                  outlined
                />
              <v-card class="pa-2" color="#efefef">
                  <p class="sm-font text-info">* Configuration for bottle component only</p>
                  
                   <v-autocomplete
                      v-model="product.complete_code"
                      label="Complete code"
                      dense
                      outlined
                      item-text="code"
                      item-value="code"
                      :items="CONTAINERS"
                    />
                    <v-autocomplete
                      v-model="product.shell_code"
                      label="Shell Code"
                      dense
                      outlined
                      item-text="code"
                      item-value="code"
                      :items="CONTAINERS"
                    />
                    <v-text-field 
                      v-model="product.num_of_bottle"
                      label="Bottles per shell"
                      dense
                      type="number"
                      outlined
                      hide-details
                    />
                
              </v-card>
              </v-col>
          </v-row>
          </v-form>
        </v-card-text>
         
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn  small color="success" rounded depressed  @click="validate()"><v-icon small left>mdi-check</v-icon>{{BTN_TEXT}}</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  mapMutations
} from 'vuex'
export default {
  props: {
    show: {
        type: Boolean,
        default: false
    },
    item:{
      type: Object,
      default: ()=>{}
    },
    state: {
        type: String,
        default:'new'
    }
  },
  data: () => ({
      product:{},
        valid: true,
      textRules: [
        v => !!v || 'Field is required'
      ],
  }),
  computed: {
      BTN_TEXT() {
          if(this.state == 'new')
            return "Add"
         else 
            return "SAVE"
      },
      CONTAINERS(){
        var arr =  this.$store.state.products.reduce((res, item)=>{
            if(item.type=="empties") {
                res.push(item)
            }
            return res
        },[])
        return arr
      },
      SIZES(){
           var arr =  this.$store.state.settings.reduce((res, item)=>{
            if(item.alias=="bottle_size") {
                res = item.value.split(',')
            }
            return res
        },[])
        return arr
      }
  },
  watch: {
    show(v) {
      if(v) {
        if(this.state !='new') {
          this.product = this.item
        } else {
          this.product = {}
        }
      }
    }
  },
  methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText']),
  validate(){

     if (this.$refs.form.validate()) {
         this.Save()
        }
  },
    emitToParent (action) {
      this.$emit('DialogEvent', action)
    },
    Save(){
      this.product.num_item_per_unit = '1'
      this.product.code = this.product.code.trim()
      this.product.sort = this.$IsNum(this.product.sort) 
       this.$http.post(this.state!='new'?'product/update':'product/add', this.product).then(response => {
            this.GET_RESPONSE(response)
           this.$emit('DialogEvent', "close")
          }).catch(e => {
            console.log(e.data)
        }) 
    }
  }
}
</script>
